import { WifiOff } from 'lucide-react';
import { useOnline } from '../../hooks/useOnline';

/**
 * Persistent banner shown while the browser is offline. Sits below
 * the TopBar but above page content so the operator is never in
 * doubt about why a station-view click feels different. The PWA
 * service worker queues KitIssued / KitReturned POSTs in IndexedDB
 * and replays them automatically when the connection returns.
 */
export function OfflineIndicator() {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 border-b border-warning/30 bg-warning-soft/15 px-3 py-2 text-xs font-medium text-warning-soft-fg print:hidden"
    >
      <WifiOff className="h-3.5 w-3.5" aria-hidden />
      <span>
        You&apos;re offline. Signed events will queue and send automatically
        when the connection returns.
      </span>
    </div>
  );
}
